export default __webpack_public_path__ + "static/media/1900.d693fca4.png";